/**
 * City lookup against /v1/search/geo for Alpine city pickers.
 */

/**
 * @param {string} query
 * @param {{ signal?: AbortSignal, limit?: number }} [options]
 * @returns {Promise<Array<{id: string, name: string, regionName: string, countryName: string, countryIso: string, population: number|undefined}>>}
 */
export async function searchCities(query, { signal, limit = 10 } = {}) {
    const response = await fetch(`/v1/search/geo?type=city&limit=${limit}&text=${encodeURIComponent(query)}`, { signal });
    if (!response.ok) {
        throw new Error(`City search failed with HTTP ${response.status}`);
    }
    const data = await response.json();

    return (data?.data || []).map(city => ({
        id: String(city.id),
        name: city.name,
        regionName: city.parent_names?.region || '',
        countryName: city.parent_names?.country || '',
        countryIso: city.country_iso || '',
        population: city.population
    }));
}

/**
 * "Region, Country" under a city name. The region rule matches genCityAcOptions in jq-common.js.
 * @param {{regionName: string, countryName: string, countryIso: string, population: number|undefined}} city
 * @returns {string}
 */
export function cityDetail(city) {
    const showRegion = city.regionName && (['US', 'CA'].includes(city.countryIso) || city.population < 100000);

    return [showRegion ? city.regionName : '', city.countryName].filter(Boolean).join(', ');
}
